import React from 'react';
import PropTypes from 'prop-types';
import Fab from '@material-ui/core/Fab';
import InputAdornment from '@material-ui/core/InputAdornment';
import { useNkStyles } from '../../infrastructure/theme';

// NK

type NkButtonProps = {
  name?: string;
  variant?: 'extended' | 'round';
  color?: 'default' | 'inherit' | 'primary' | 'secondary';
  size?: 'small' | 'medium' | 'large';
  label?: string;
  onClick: () => void;
  isDisabled?: boolean;
  isRequesting?: boolean;
  icon: (props: any) => any;
};

const NkButton = (props: NkButtonProps) => {
  const classes = useNkStyles();

  return (
    <div>
      <div>
        <Fab
          name={props.name}
          variant={props.variant}
          color={props.color}
          size={props.size || 'medium'}
          onClick={props.onClick}
          disabled={props.isRequesting || props.isDisabled}
        >
          {props.label ? (
            <React.Fragment>
              <InputAdornment position="start">
                <props.icon />
              </InputAdornment>
              {props.label}
            </React.Fragment>
          ) : (
            <props.icon />
          )}
        </Fab>
      </div>
    </div>
  );
};

NkButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
  isRequesting: PropTypes.bool,
  label: PropTypes.string,
  icon: PropTypes.func.isRequired,
  variant: PropTypes.oneOf(['extended', 'round']),
  color: PropTypes.oneOf(['default', 'inherit', 'primary', 'secondary']),
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  align: PropTypes.oneOf(['right', 'left', 'center']),
  style: PropTypes.object,
  name: PropTypes.string,
};

export default NkButton;
